import { useTranslate } from "@similarweb/i18n-provider";
import type { ActivationAlertsContractDisplayAdAlert } from "@similarweb/pro-api-client";
import { formatDate, shortMonthDayAndYear } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { DetailsRow } from "../../../../common/modal/details-rows/DetailsRow";
import { NewTabLinkRow } from "../../../../common/modal/details-rows/NewTabLinkRow";
import { DurationRow } from "../details-rows/DurationRow";
import { TypeRow } from "../details-rows/TypeRow";

interface IAdDetailsSectionProps {
    ad: ActivationAlertsContractDisplayAdAlert;
}

export const AdDetailsSection = ({ ad }: IAdDetailsSectionProps) => {
    const { translate } = useTranslate();

    const activeDays = "activeDays" in ad ? ad.activeDays : null;
    const lastSeen = "lastSeen" in ad ? ad.lastSeen : null;
    const dimensions = "dimensions" in ad ? ad.dimensions : null;
    const adType = "adType" in ad ? ad.adType : null;

    const seenRange = lastSeen
        ? `${formatDate(ad.firstSeen, undefined, shortMonthDayAndYear)} – ${formatDate(lastSeen, undefined, shortMonthDayAndYear)}`
        : formatDate(ad.firstSeen, undefined, shortMonthDayAndYear);

    return (
        <Stack
            gap="16px"
            minWidth={0}
        >
            <Text
                fontVariant="h5_2"
                color={colorsPalettes.carbon[500]}
            >
                {translate("activation.alerts.cards.display-ads.modal.ad-details")}
            </Text>

            <DurationRow activeDays={activeDays} />

            <DetailsRow label={translate("activation.alerts.cards.display-ads.modal.seen")}>
                <Text
                    fontVariant="input2"
                    color={colorsPalettes.carbon[500]}
                >
                    {seenRange}
                </Text>
            </DetailsRow>

            {dimensions ? (
                <DetailsRow label={translate("activation.alerts.cards.display-ads.modal.dimensions")}>
                    <Text
                        fontVariant="input2"
                        color={colorsPalettes.carbon[500]}
                    >
                        {dimensions}
                    </Text>
                </DetailsRow>
            ) : null}

            {adType ? <TypeRow type={adType} /> : null}

            <NewTabLinkRow
                label={translate("activation.alerts.cards.display-ads.modal.landing-page")}
                url={ad.landingPage}
            />
        </Stack>
    );
};
